const commonInitialState = {
  pages:         [],
  headSlider:    [],
  notifications: [],
  banners:       [],
  discount:      {},
  // Path the server answered with 404 (see NotFoundPageRenderer); Router shows Notfound for exactly it
  notFoundPath:  null,
  pagesLoaded:   false,
  loading:       false,
};

export default commonInitialState;